import { cn } from "@/lib/utils";

import { SelectionCard } from "@/components/clients/selection-card";

export type SelectionOption = {
  id: string;
  title: string;
  description: string;
};

export type SelectionCardGroupProps = {
  options: SelectionOption[];
  value?: string;
  onChange?: (id: string) => void;
  className?: string;
  cardClassName?: string;
  "aria-label"?: string;
};

/**
 * Horizontal group of {@link SelectionCard} tiles with single-select behavior.
 */
export function SelectionCardGroup({
  options,
  value,
  onChange,
  className,
  cardClassName,
  "aria-label": ariaLabel = "Options",
}: SelectionCardGroupProps) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className={cn(
        "flex w-full flex-col items-stretch gap-[14px] sm:flex-row sm:flex-wrap sm:items-stretch lg:flex-nowrap",
        className,
      )}
    >
      {options.map((option) => (
        <SelectionCard
          key={option.id}
          title={option.title}
          description={option.description}
          selected={value === option.id}
          className={cardClassName}
          onClick={() => onChange?.(option.id)}
        />
      ))}
    </div>
  );
}
